






















// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import SubscriptionsTable from '../components/SubscriptionsTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    CardComponent,
    SubscriptionsTable,
  },
})
export default class SubscriptionList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Programmations'];
  }
}
